<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <v-form
          ref="form"
          lazy-validation
          class="app-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
        >
          <v-card
            class="app-card"
            elevation="0"
          >
            <v-card-title class="app-card-title">
              <h4 class="text">
                <span>Editar Transportadora</span>
              </h4>
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-row>
                <v-col
                  :lg="8"
                  :md="8"
                  :sm="12"
                  class="pb-0"
                >
                  <v-text-field
                    :value="form.name"
                    outlined
                    dense
                    disabled
                    label="Razão Social"
                    hint="Não editável"
                    persistent-hint
                  />
                </v-col>
                <v-col
                  :lg="4"
                  :md="4"
                  :sm="12"
                  class="pb-0"
                >
                  <v-text-field
                    :value="form.cnpj"
                    outlined
                    dense
                    disabled
                    label="CNPJ"
                    hint="Não editável"
                    persistent-hint
                  />
                </v-col>
              </v-row>

              <v-divider class="my-4" />
              <h4 class="text mb-2">
                Contato
              </h4>
              <v-row>
                <v-col
                  :lg="6"
                  :md="6"
                  :sm="12"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.email"
                    outlined
                    dense
                    label="Email *"
                    placeholder="Digite o email"
                    :rules="[rules.required, rules.email]"
                  />
                </v-col>
                <v-col
                  :lg="6"
                  :md="6"
                  :sm="12"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.cell_phone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    outlined
                    dense
                    label="Telefone *"
                    placeholder="(00) 00000-0000"
                    :rules="[rules.required, rules.phone]"
                  />
                </v-col>
              </v-row>

              <v-divider class="my-4" />
              <h4 class="text mb-2">
                Endereço
              </h4>
              <v-row>
                <v-col
                  :lg="3"
                  :md="3"
                  :sm="6"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.address.zipcode"
                    outlined
                    dense
                    label="CEP"
                    placeholder="00000-000"
                    :loading="isSearchingCep"
                    @blur="searchCep"
                  />
                </v-col>
                <v-col
                  :lg="6"
                  :md="6"
                  :sm="12"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.address.address"
                    outlined
                    dense
                    label="Logradouro"
                    placeholder="Rua, avenida..."
                  />
                </v-col>
                <v-col
                  :lg="3"
                  :md="3"
                  :sm="6"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.address.number"
                    outlined
                    dense
                    label="Número"
                  />
                </v-col>
                <v-col
                  :lg="4"
                  :md="4"
                  :sm="6"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.address.complement"
                    outlined
                    dense
                    label="Complemento"
                  />
                </v-col>
                <v-col
                  :lg="4"
                  :md="4"
                  :sm="6"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.address.district"
                    outlined
                    dense
                    label="Bairro"
                  />
                </v-col>
                <v-col
                  :lg="3"
                  :md="3"
                  :sm="6"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.address.city"
                    outlined
                    dense
                    label="Cidade"
                  />
                </v-col>
                <v-col
                  :lg="1"
                  :md="1"
                  :sm="6"
                  class="pb-0"
                >
                  <v-text-field
                    v-model="form.address.state"
                    outlined
                    dense
                    maxlength="2"
                    label="UF"
                  />
                </v-col>
              </v-row>

              <v-divider class="my-4" />
              <div class="d-flex">
                <v-spacer />
                <v-btn
                  outlined
                  color="error"
                  type="button"
                  class="mr-2"
                  :to="{ name: 'dashboard-empresas-list' }"
                >
                  Voltar
                </v-btn>
                <v-btn
                  depressed
                  color="success"
                  type="submit"
                  :disabled="detail.isLoading"
                >
                  Salvar
                </v-btn>
              </div>
            </v-card-text>
            <section
              v-if="detail.isLoading"
              class="loading"
            >
              <v-progress-circular
                indeterminate
                color="success"
              />
              <span>Enviando informações ...</span>
            </section>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import { mask } from 'vue-the-mask';
  import CepService from '@/services/cep.service';

  export default {
    name: 'EmpresaForm',

    // Registrada localmente de propósito: a diretiva não é registrada
    // globalmente no main.ts, e registrá-la agora faria as máscaras de
    // PaymentCartao.vue (hoje inertes) passarem a valer, mudando o
    // comportamento daquela tela.
    directives: { mask },

    data: () => ({
      isSearchingCep: false,
      form: {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        cell_phone: null,
        address: {
          address: null,
          number: null,
          complement: null,
          zipcode: null,
          district: null,
          city: null,
          state: null
        }
      },
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
        email: value => {
          var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(value) || 'E-mail fora do padrão';
        },
        phone: value => {
          const digits = (value || '').replace(/\D/g, '');
          return digits.length === 10 || digits.length === 11 ||
            'Telefone deve ter 10 ou 11 dígitos com o DDD';
        }
      }
    }),

    computed: {
      ...mapState('empresa', ['detail'])
    },

    watch: {
      // Sincroniza o formulário sempre que o detalhe muda: no carregamento e
      // também após salvar, já que permanecemos na tela de edição.
      'detail.data': {
        immediate: true,
        handler(data) {
          if (!data) return;

          this.form = { ...data, address: { ...data.address } };
        }
      }
    },

    mounted() {
      this.initData();
    },

    destroyed() {
      this.clearResource();
    },

    methods: {
      onSubmit() {
        if (!this.$refs.form.validate()) return;

        const { id, email, cell_phone, address } = this.form;
        this.update({ id, email, cell_phone, address });
      },

      async initData() {
        const { params: { id } } = this.$route;

        await this.getEmpresa(id);
      },

      // O CepService devolve o corpo já desembrulhado, no formato da BrasilAPI
      // ({ cep, state, city, neighborhood, street }) — mesmo uso de
      // FormAutovistoria.vue. Campos vazios preservam o que já estava digitado.
      async searchCep() {
        const zipcode = (this.form.address.zipcode || '').replace(/\D/g, '');

        if (zipcode.length !== 8) return;

        this.isSearchingCep = true;

        try {
          const { street, neighborhood, city, state } =
            await CepService.searchCEP(zipcode).toPromise();

          this.form.address = {
            ...this.form.address,
            address: street || this.form.address.address,
            district: neighborhood || this.form.address.district,
            city: city || this.form.address.city,
            state: state || this.form.address.state
          };
        } catch (error) {
          // CEP não encontrado: mantém o preenchimento manual
        } finally {
          this.isSearchingCep = false;
        }
      },

      ...mapActions('empresa', { update: 'UPDATE' }),
      ...mapActions('empresa', { getEmpresa: 'SHOW' }),
      ...mapActions('empresa', { clearResource: 'CLEAR_DETAIL' })
    }
  };
</script>
